function accountShowInfoTrigger() {
	$(".accountShowInfoTrigger").on("click", function() {
		$(this).toggleClass("triggered");
		$(".accountShowInfo-triggered").toggleClass("is-hided");
		if (
			$(this)
				.find("span")
				.text() == "Show other details"
		) {
			$(this)
				.find("span")
				.text("Hide");
		} else {
			$(this)
				.find("span")
				.text("Show other details");
		}
	});
}